import React, {FunctionComponent, useEffect} from 'react';
import {useForm} from 'b302-frontend-library';

import HanSearch from '../../../utils/HanSearch';

interface Props {
    children?: any;
    title: string;
    searchQuery: string;
    onSearch: (e: any) => void;
    searchPlaceholder?: string;
}

const FilterPageHeader: FunctionComponent<Props> = ({ children, title, searchQuery, onSearch, searchPlaceholder }) => {

    const [form, onFormChange] = useForm<{ query: string }>(f => ({
        query: f.input(searchQuery)
    }));

    useEffect(() => {
        onSearch(form.values.query);
    }, [form.values.query]);

    return (
        <div className={'filter-page__header'}>
            <h1 className={'filter-page__title'}>{ title }</h1>

            { children }

            <HanSearch
                id={'query'}
                form={form}
                onChange={onFormChange}
                className={'filter-page__search'}
                placeholder={searchPlaceholder ?? 'Search'}/>
        </div>
    );
};

export default FilterPageHeader;
